import { useCallback, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useSelection } from '../SelectionContext';
import useBusinessResource from '../hooks/useBusinessResource';
import useAuditScope from './useAuditScope';
import { getAuditDashboard, auditDashboardLogUrl } from '../mobile/audit/auditMobileApi';

// Même ressource et mêmes filtres sur ordinateur et mobile. Chaque ouverture,
// focus, reconnexion et clic sur Actualiser relit le serveur sans cache d'agrégat.
export default function useAuditDashboard() {
  const { user } = useAuth();
  const { selectedWarehouse } = useSelection();
  const scope = useAuditScope();
  const [period, setPeriod] = useState(7);
  const [includeAuth, setIncludeAuth] = useState(true);
  const warehouseId = scope.scope === 'all' ? null : selectedWarehouse;
  const companyId = scope.scope === 'all' ? null : scope.companyId;
  const load = useCallback((signal) => getAuditDashboard(period, companyId, {
    scope: scope.scope, warehouseId, includeAuth, fresh: true, signal,
  }), [companyId, includeAuth, period, scope.scope, warehouseId]);
  const resource = useBusinessResource({
    resource: 'audit-dashboard', userId: user?.id, companyId, warehouseId,
    moduleScope: 'audit', scopeLevel: scope.scope === 'all' ? 'user' : 'company',
    parameters: [scope.scope, period, includeAuth], enabled: true, active: true, load,
  });
  const refresh = () => { void resource.refresh({ force: true }).catch(() => {}); };
  const logUrl = (options = {}) => auditDashboardLogUrl(resource.data, {
    scope: scope.scope, warehouseId, includeAuth, ...options,
  });
  return { ...scope, ...resource, period, setPeriod, includeAuth, setIncludeAuth, warehouseId,
    refresh, logUrl };
}
